import { reduxStore } from '../../index';
import { CLEAR_DATA } from 'redux/actions/types';

if (process.env.REACT_APP_DEBUG === 'true') {
  window.SUPPORT = {
    clearData: () => {
      const { store } = reduxStore;
      store.dispatch({
        type: CLEAR_DATA,
      });
    },
  };
}

console._log = (...args) => {
  if (process.env.REACT_APP_DEBUG === 'true') {
    console.log(...args);
  }
};

console._warn = (...args) => {
  if (process.env.REACT_APP_DEBUG === 'true') {
    console.warn(...args);
  }
};

console._error = (...args) => {
  if (process.env.REACT_APP_DEBUG === 'true') {
    console.error(...args);
  }
};
